export default __webpack_public_path__ + "static/media/notes-icon.b274134a.svg";